.childrenContainer {
  flex: 1;
  align-self: flex-end;
}
